import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, ExpandedTooltip, Icon, InputWithIcon } from '@livable/saas-react-components';
import { Autocomplete, Button, IconButton, Paper, TextField,
// ToggleButton,
// ToggleButtonGroup,
Typography } from '@mui/material';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddProviderModalV2 } from 'src/components/property/PropertyUtilitiesSetupPageV2/AddProviderModalV2';
import ProvidersCredentialsModal from 'src/components/property/PropertyUtilitiesSetupPageV2/ProvidersCredentialsModal';
import { useStore } from 'src/stores';
import { UtilityAccordion } from '../UtilityAccordion';
import { ProviderSetupModal } from '../ProviderSetupModal';
import useUtilityProviderSetupV2Styles from './styles';
import { AssociatedVendorModal } from 'src/components/shared/AssociatedVendor/modal';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import { findCredentialForUtility } from 'src/components/property/UtilityPortalCredentials';
import { UtilityCredentialStatusLine } from 'src/components/property/UtilityPortalCredentials/UtilityCredentialStatusLine';
import { answered } from 'src/components/property/UtilityPortalCredentials/asyncResult';
import { isLivableStaffFromToken } from 'src/utils/isLivableStaffFromToken';
import { currentCompanyId } from 'src/components/property/UtilityPortalCredentials/currentCompanyId';
export const UtilityProviderSetupV2 = observer(_ref => {
  var _store$addNewProperty, _store$addNewProperty3, _store$addNewProperty4;
  let isEdit = _ref.isEdit,
    propertyId = _ref.propertyId,
    onSave = _ref.onSave,
    isParentLoading = _ref.isParentLoading;
  const classes = useUtilityProviderSetupV2Styles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // const [billsMethod, setBillsMethod] = useState('myself');
  //   const handleBillsMethodChange = (e, value) => {
  //       if (value) setBillsMethod(value);
  //   };

  const _useReducer = useReducer(o => !o),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    searchResultItems = _useState2[0],
    setSearchResultItems = _useState2[1];

  // Credential state for this property's utilities, staff only.
  //
  // The billing-templates surface shows this already; a customer without that flag falls back to
  // this component, and staff sudo'ing in had no way to see whether a portal login was stored. Only
  // the read-only line is lifted across: entry still lives in the utility configuration modal, which
  // already renders the shared slot on both the flagged and unflagged paths.
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    portalCredentials = _useState4[0],
    setPortalCredentials = _useState4[1];
  // A failed or superseded lookup is not "no credentials saved". run() resolves undefined for both
  // a swallowed API error and a cancellation, so an empty list here is indistinguishable from a
  // healthy property with nothing stored - and the line then tells an operator to create a login
  // that may already exist. Same fix the other three surfaces carry.
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    credentialsUnavailable = _useState6[0],
    setCredentialsUnavailable = _useState6[1];
  const isLivableStaff = isLivableStaffFromToken();
  useEffect(() => {
    const companyId = currentCompanyId();
    if (!isLivableStaff || !companyId || !propertyId) return undefined;
    let cancelled = false;
    setCredentialsUnavailable(false);
    // Additive to this page: a failure leaves the utility list fully usable rather than blocking it.
    store.admin.getUtilityCredentialsAsync.run({
      companyId,
      propertyId
    }).then(resp => {
      if (cancelled) return;
      const rows = (resp === null || resp === void 0 ? void 0 : resp.response) || resp;
      // answered(), not just isError: the model swallows API errors AND cancels, resolving
      // undefined either way with isError false for a cancel.
      if (!answered(resp) || store.admin.getUtilityCredentialsAsync.isError || !Array.isArray(rows)) {
        setCredentialsUnavailable(true);
        setPortalCredentials([]);
        return;
      }
      setPortalCredentials(rows.filter(Boolean));
    }).catch(() => {
      if (cancelled) return;
      setCredentialsUnavailable(true);
      setPortalCredentials([]);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLivableStaff, propertyId]);
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isProviderSetupModalOpen = _useState8[0],
    setProviderSetupModalOpen = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    openedProviders = _useState0[0],
    setOpenedProviders = _useState0[1];
  const handleAccordionChange = event => {
    const accordionId = event;
    if (!openedProviders.includes(accordionId)) {
      setOpenedProviders(prevValues => [...prevValues, accordionId]);
    } else {
      setOpenedProviders(prevValues => prevValues.filter(prevValue => prevValue !== accordionId));
    }
  };
  const handleNewProviderConfigChange = data => {
    store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration(data);
  };
  let searchUtilityProvidersHandler;
  const searchUtilityProviders = async (event, value) => {
    if (value && value.length > 0) {
      if (searchUtilityProvidersHandler) {
        // setSearchResultItems([]);
        clearTimeout(searchUtilityProvidersHandler);
      }
      searchUtilityProvidersHandler = setTimeout(() => store.utilityProviders.searchUtilityProvidersAsync.run(value).then(resp => {
        setSearchResultItems(resp.response.map(item => {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: item.value,
            id: item.key,
            key: item.key
          });
        }));
      }), 350);

      // return resp.response;
    } else {
      if (searchUtilityProvidersHandler) clearTimeout(searchUtilityProvidersHandler);
    }
    setSearchResultItems([]);
  };
  const configureUtilityProvider = async (event, value) => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    if (value && value !== null && value !== void 0 && value.id) {
      await store.utilityProviders.getUtilityProvidersListDataAsync.run({
        utilityProviderIds: [value.id]
      }).then(async resp => {
        if (resp && resp.isSuccessful) {
          var _singleElementOfArray;
          // setProviderSetupModalOpen(true);
          store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(singleElementOfArray(resp.response));
          await store.utilityProviders.getUtilityInfoAsync.run({
            utilityIds: (_singleElementOfArray = singleElementOfArray(resp.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.utilities.map(i => i.id)
          });
          setProviderSetupModalOpen(true);
        }
      });
    }
  };
  const saveUtilityProvider = async () => {
    clearTimeout(searchUtilityProvidersHandler);
    setSearchResultItems([]);
    store.addNewProperty.utilitiesSetupV2.addProvider(_objectSpread(_objectSpread({}, toJS(store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator)), {}, {
      id: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator).providerId,
      name: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator).providerName
    }), false);
    store.addNewProperty.utilitiesSetupV2.selectUtilities({
      utilities: toJS(store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator.utilities)
    });
    setProviderSetupModalOpen(false);
    onSave({
      goNext: false,
      forceNextStep: false
    });
  };
  const removeSubmitUtilityProvider = async value => {
    if (isEdit || value.isFetched) {
      store.addNewProperty.utilitiesSetupV2.addUtilityProviderToDelete(value);
    }
    store.addNewProperty.utilitiesSetupV2.removeProvider(value);
  };
  return /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper",
    style: {
      zIndex: 98
    }
  }, store.company.companyFeatureStore.isAppfolio && !store.addNewProperty.utilitiesSetupV2.globalGlAccountExternalId && !isParentLoading && /*#__PURE__*/React.createElement("div", {
    className: classes.glLoader
  }, "Please select Default GL account first"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.utility_provider_setup'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: t('add_new_property_flow.utility_setup_tooltip'),
    type: "grey"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "warning",
    type: "info"
  })))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('add_new_property_flow.utility_provider_setup_hint')), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.add_your_providers')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    id: "provider-selector",
    key: "key-provider-selector",
    variant: "withIcon",
    disablePortal: true
    // openOnFocus
    ,
    loading: store.utilityProviders.searchUtilityProvidersAsync.inProgress,
    clearIcon: null,
    popupIcon: null,
    value: "",
    options: searchResultItems,
    onInputChange: searchUtilityProviders,
    onChange: configureUtilityProvider,
    renderInput: params => /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      id: "provider-selector",
      label: t('add_new_property_flow.provider_search')
    })))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(AddProviderModalV2, {
    key: "add-utility-providerV2",
    isEditMode: false,
    propertyId: propertyId,
    onSave: onSave,
    isDetailsPage: isEdit
  }))), (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.getUtilityProviders) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.map(provider => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.provider,
      key: "key_util_provider_".concat(provider.id),
      id: "id_util_provider_".concat(provider.id)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.providerTitle
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.providerTitleDetails
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, provider.name), store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled && /*#__PURE__*/React.createElement("div", {
      className: classes.providerTitleAppfolio
    }, "Appfolio provider name: ", /*#__PURE__*/React.createElement("b", null, store.vendors.getVendorName(provider.id)), ' ', /*#__PURE__*/React.createElement(AssociatedVendorModal, {
      forceUpdate: forceUpdate,
      utilityProviderId: provider.id,
      customTrigger: /*#__PURE__*/React.createElement("span", {
        className: classes.providerTitleAppfolioModal
      }, "change")
    }))), /*#__PURE__*/React.createElement("div", {
      className: classes.providerActions
    }, provider.isCustom && /*#__PURE__*/React.createElement(AddProviderModalV2, {
      id: "ID-edit-utility-providerV2+".concat(provider.id),
      key: "edit-utility-providerV2+".concat(provider.id),
      isEditMode: provider.isCustom,
      trigger: /*#__PURE__*/React.createElement(Button, {
        variant: "text",
        size: "small",
        'custom-attribute': '215-UtilityProvidersSetupV2'
      }, t('general.edit')),
      provider: provider,
      propertyId: propertyId,
      onSave: onSave
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      onClick: () => removeSubmitUtilityProvider(provider),
      'custom-attribute': '216-UtilityProvidersSetupV2'
    }, t('add_new_property_flow.remove_provider')))), store.addNewProperty.utilitiesSetupV2.getPropertyUtilitySetupByProvider(provider.id).filter(utility => provider.isCustom ? utility.isEnabled : true).map(utility => /*#__PURE__*/React.createElement(UtilityAccordion, {
      credentialLine: /*#__PURE__*/React.createElement(UtilityCredentialStatusLine, {
        credential: findCredentialForUtility(portalCredentials, utility.propertyUtilityId),
        isVisible: isLivableStaff,
        unavailable: credentialsUnavailable
      }),
      utility: _objectSpread({}, utility),
      id: "ID-".concat((utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityId)),
      key: "KEY-".concat((utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityId)),
      isEdit: true,
      propertyId: propertyId,
      hideNotEnabled: !openedProviders.includes("".concat(provider.id)),
      customMode: provider.isCustom && utility.isCustom && false
      // readOnly
      ,
      enableRemove: provider.isCustom,
      disableToggler: provider.isCustom,
      propertySqFootageExternal: store.addNewProperty.utilitiesSetupV2.getPropertySqFootage
    })), !provider.isCustom && /*#__PURE__*/React.createElement("div", {
      className: classes.mdSection
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      onClick: e => {
        var _store$addNewProperty2;
        e.preventDefault();
        if (((_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.getPropertyUtilitySetupByProvider(provider.id).filter(ut => !ut.isEnabled)) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.length) > 0) handleAccordionChange(provider.id);
      },
      disabled: store.addNewProperty.utilitiesSetupV2.getPropertyUtilitySetupByProvider(provider.id).filter(ut => !ut.isEnabled).length === 0,
      'custom-attribute': '217-UtilityProvidersSetupV2'
    }, !openedProviders.includes("".concat(provider.id)) && store.addNewProperty.utilitiesSetupV2.getPropertyUtilitySetupByProvider(provider.id).filter(ut => !ut.isEnabled).length === 0 ? /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-on"
    }) : /*#__PURE__*/React.createElement(Icon, {
      type: "show-eye-off"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, !openedProviders.includes("".concat(provider.id)) && store.addNewProperty.utilitiesSetupV2.getPropertyUtilitySetupByProvider(provider.id).filter(ut => !ut.isEnabled).length > 0 ? 'Show unselected utilities' : 'Hide unselected utilities'))), store.addNewProperty.utilitiesSetupV2.selectedUtilities.length < 0 && /*#__PURE__*/React.createElement("div", {
      className: classes.mdSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, t('add_new_property_flow.upload_bills_into_system')), /*#__PURE__*/React.createElement("div", {
      className: classes.billsActions
    }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
      value: billsMethod,
      onChange: handleBillsMethodChange,
      size: "small",
      exclusive: true
    }, /*#__PURE__*/React.createElement(ToggleButton, {
      'custom-attribute': '217-UtilityProvidersSetupV2-myself',
      value: "myself"
    }, t('add_new_property_flow.provide_bills_myself')), /*#__PURE__*/React.createElement(ToggleButton, {
      'custom-attribute': '217-UtilityProvidersSetupV2-livable',
      value: "livable"
    }, t('add_new_property_flow.downloaded_by_livable'))), billsMethod === 'livable' && /*#__PURE__*/React.createElement(ProvidersCredentialsModal, null))));
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isParentLoading || store.properties.getPropertyAsync.inProgress || store.amenities.getAllCommonAreaAmenitiesRawAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.addPropertyCommonAreaAmenityAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.amenities.getAllAmenitiesRawAsync.inProgress || store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.deletePropertyUtilityProvidersAsync.inProgress || store.utilityProviders.getUtilityProvidersListDataAsync.inProgress || store.utilityProviders.getUtilityInfoAsync.inProgress
  }), /*#__PURE__*/React.createElement(ProviderSetupModal, {
    key: "KEY_NEW_ProviderSetupModal",
    id: "ID_NEW_ProviderSetupModal",
    externalIsOpen: isProviderSetupModalOpen,
    externalHandleOpen: () => setProviderSetupModalOpen(true),
    externalHandleClose: () => {
      setProviderSetupModalOpen(false);
      clearTimeout(searchUtilityProvidersHandler);
      setSearchResultItems([]);
    },
    utilityProviderId: (_store$addNewProperty3 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty3 === void 0 ? void 0 : _store$addNewProperty3.providerId,
    utilityProviderName: (_store$addNewProperty4 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.providerName,
    isEdit: false,
    isDetailsPage: isEdit,
    handleConfigChange: handleNewProviderConfigChange,
    onSave: saveUtilityProvider,
    propertyId: propertyId
  }));
});